import { publicApiConfig } from '#apps/client-web/app/config/public-api';
import { AuthenticationError } from '#packages/data-collection/types/authentication-error';

export type ExportApiServiceOptions = {
  baseUrl: string;
};

export class ExportApiService {
  private readonly opts: ExportApiServiceOptions;

  constructor(opts: ExportApiServiceOptions) {
    this.opts = opts;
  }

  private buildHeaders(
    accessToken: string | undefined,
    extra?: Record<string, string>,
  ): HeadersInit {
    return {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...extra,
    };
  }

  private joinUrl(base: string, ...paths: string[]): string {
    const normalizedBase = base.replace(/\/+$/, '');

    const normalizedPaths = paths
      .map((p) => p.replace(/^\/+|\/+$/g, ''))
      .filter(Boolean);

    return [normalizedBase, ...normalizedPaths].join('/');
  }

  async getTemplateDownloadUrl({
    templateId,
    accessToken,
  }: {
    templateId: string;
    accessToken: string | undefined;
  }): Promise<string> {
    const response = await fetch(
      this.joinUrl(
        this.opts.baseUrl,
        `v1/templates/${encodeURIComponent(templateId)}/download`,
      ),
      {
        method: 'GET',
        headers: this.buildHeaders(accessToken),
      },
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new AuthenticationError();
      }
      throw new Error(
        `Template download failed: ${response.status} ${response.statusText}`,
      );
    }

    const body = await response.json();
    return body.data.url as string;
  }
}

export const exportApiService = new ExportApiService({
  baseUrl: publicApiConfig.baseUrl,
});
